var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"input-center",staticStyle:{"min-width":"150px","max-width":"150px","margin-left":"auto"},attrs:{"single-line":_vm.dense,"dense":_vm.dense,"label":_vm.dense ? '' : _vm.label,"hide-details":_vm.showMessages
      ? false
      : _vm.dense
      ? !_vm.errorMessages || _vm.errorMessages.length == 0
      : false,"type":"number","min":_vm.min ? _vm.min : 0,"max":_vm.max ? _vm.max : 99999999,"error-messages":_vm.errorMessages},on:{"blur":function($event){_vm.number = _vm.number >= (_vm.min ? _vm.min : 0) ? _vm.number : _vm.min ? _vm.min : 0;
    _vm.number = _vm.number <= (_vm.max ? _vm.max : 99999999) ? _vm.number : _vm.max;
    _vm.number = _vm.$numberFormatter.formatWithDotNoMoreThan(
      _vm.number,
      Number.isInteger(_vm.dot) ? _vm.dot : 2,
      true
    );}},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"pt-2 pb-1 primary--text",attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();_vm.number =
          Number(_vm.number) - 1 >= (_vm.min ? _vm.min : 0)
            ? Number(_vm.number) - 1
            : _vm.min
            ? _vm.min
            : 0}}},[_vm._v(" fa-minus ")])]},proxy:true},{key:"append",fn:function(){return [_c('v-icon',{staticClass:"pt-2 pb-1 primary--text",attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();_vm.number = _vm.number
          ? Number(_vm.number) + 1 <= (_vm.max ? _vm.max : 99999999)
            ? Number(_vm.number) + 1
            : _vm.max
          : 1}}},[_vm._v(" fa-plus ")])]},proxy:true},{key:"append-outer",fn:function(){return [_vm._t("append")]},proxy:true}],null,true),model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})}
var staticRenderFns = []

export { render, staticRenderFns }